<ul class="navbar-nav ml-auto" [class]="backgroundStyle">
    <li>
        <span *ngIf="this.gradientConfig['layout'] != 'vertical'" class="version-txt" style="color: white;margin-right:20px;">VERSION {{versionInfo}}</span>
    </li>&nbsp;&nbsp;&nbsp;&nbsp;


    <li>
        <div class="dropdown" ngbDropdown placement="auto" [class]="backgroundStyle">
            <div>
                <a ngbDropdownToggle href="javascript:" data-toggle="dropdown"><i class="icon feather icon-bell" style="color: white;font-size: 20px;"></i><span class="badge bg-danger" style="top:8px;right:-4px">{{notificationData.length}}<span class="sr-only"></span></span></a>
            </div>
            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right notification" [class]="backgroundStyle" style="max-width: 310px; min-width: 310px;">
                <div class="noti-head">
                    <h6 class="d-inline-block m-b-0">Notifications - <span style="background-color: white;color: black;padding: 5px;border-radius: 40px;">{{notificationData.length}}</span></h6>

                    <!-- <div class="float-right">
                        <a href="javascript:" class="m-r-10">mark as read</a>
                        <a href="javascript:" (click)="clearAll();">clear all</a>
                    </div> -->
                </div>
                <ul class="noti-body">
                    <!-- <li class="n-title">
                        <p class="m-b-0">NEW</p>
                    </li> -->
                    <div style="width: 330px; overflow-y: scroll;height: 302px;">
                        <li class="list-group-item bg-light" *ngFor="let data of notificationData ;let i = index;">
                            <!-- <div class="media">
                            <p>{{i+1}}.&nbsp;<strong>{{data?.content  | slice:0:40}}</strong>&nbsp;<u><span class="pointCursor" (click)="viewMore(data);viewDetailed.show()">..show more</span></u></p>
                            <hr>
                            <br>
                        </div>
                        <hr> -->

                            <div class="row" style="border-bottom: 20px;">
                                <div class="col">
                                    <!-- <a href="#"> -->
                                    <div class="d-flex">
                                        <!-- <img src="../../assets/images/avatar/avatar-1.jpg" alt="" class="avatar-md rounded-circle"> -->
                                        <div class="ms-3">
                                            <h6 class="fw-bold mb-1">{{data.head}}</h6>
                                            <!-- <p >
                                              {{data.content | slice:0:40}}
                                            </p> -->

                                            <p class="mb-3">
                                                <!-- {{i+1}}.&nbsp;<strong> -->
                                                {{data?.content | slice:0:40}}
                                                <!-- </strong>&nbsp;<u> -->
                                                <span class="pointCursor" style="color:#008080" (click)="viewMore(data);viewDetailed.show();notificationRemoveNew(i,data);$event.prevenDefault();">..show more</span>
                                                <!-- </u> -->
                                            </p>


                                            <!-- <span class="fs-6 text-muted">
                                                <span><span class="fe fe-thumbs-up text-success me-1"></span>2 hours ago,</span>
                                                <span class="ms-1">2:19 PM</span>
                                            </span> -->
                                        </div>
                                    </div>
                                    <!-- </a> -->

                                </div>
                                <div class="col-auto text-center">
                                    <a href="#" class="bg-transparent" (click)="notificationRemove(i,data);$event.prevenDefault();">
                                        <!-- <i class="fe fe-x text-muted"></i> -->
                                        <i class="fa fa-times" style="color: rgb(237, 69, 69);" aria-hidden="true"></i>
                                    </a>
                                </div>
                            </div>

                        </li>
                    </div>

                    <!-- <li class="n-title">
                        <p class="m-b-0">EARLIER</p>
                    </li>
                    <li class="notification">
                        <div class="media">
                            <img class="img-radius" src="assets/images/user/avatar-2.jpg" alt="Generic placeholder image">
                            <div class="media-body">
                                <p><strong>Joseph William</strong><span class="n-time text-muted"><i
                                            class="icon feather icon-clock m-r-10"></i>30 min</span></p>
                                <p>Purchase New Theme and make payment</p>
                            </div>
                        </div>
                    </li>
                    <li class="notification">
                        <div class="media">
                            <img class="img-radius" src="assets/images/user/avatar-3.jpg" alt="Generic placeholder image">
                            <div class="media-body">
                                <p><strong>Sara Soudein</strong><span class="n-time text-muted"><i
                                            class="icon feather icon-clock m-r-10"></i>30 min</span></p>
                                <p>currently login</p>
                            </div>
                        </div>
                    </li> -->

                </ul>
                <!-- <div class="noti-footer">
                    <a href="javascript:">show all</a>
                </div> -->
            </div>
            <!-- <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right notification" [class]="backgroundStyle" style="max-width: 310px; min-width: 310px;">
                <div class="noti-head">
                    <h6 class="d-inline-block m-b-0">Notifications</h6>


                </div>
                <ul class="noti-body">

                    <div style="width: 330px; overflow-y: scroll;height: 257px;">
                        <li class="list-group-item bg-light" *ngFor="let data of notificationData ;let i = index;" style="border-bottom: 20px;" (click)="notificationRemove(i,data)">


                            <div class="row">
                                <div class="col">
                                    <a href="#">
                                        <div class="d-flex">
                                            <div class="ms-3">
                                                <h5 class="fw-bold mb-1">{{data.head}}</h5>
                                                <p class="mb-3">
                                                    {{data.content}}
                                                </p>

                                            </div>
                                        </div>
                                    </a>

                                </div>
                                <div class="col-auto text-center">
                                    <a href="#" class="bg-transparent" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Remove" data-bs-original-title="Remove">
                                        <i class="fa fa-times" aria-hidden="true"></i>
                                    </a>
                                </div>
                            </div>

                        </li>
                    </div>

                    
            </div> -->
        </div>
    </li>
    <li (click)="this.visibleUserList = !this.visibleUserList;">
        <div class="dropdown">
            <!-- <a href="javascript:" class="displayChatbox dropdown-toggle">
        <span class="badge bg-success"><span class="sr-only"></span></span>
      </a> -->
        </div>
    </li>
    <li>
        <div class="dropdown drp-user" ngbDropdown placement="auto">
            <a href="javascript:" ngbDropdownToggle data-toggle="dropdown" (click)="adminOpen()">
                <img src="assets/images/user/avatar.jpg" class="img-radius wid-40" alt="">
            </a>
            <div class="dropdown-menu dropdown-menu-right profile-notification" ngbDropdownMenu *ngIf="Timercard">
                <div class="pro-head">
                    <img src="assets/images/user/avatar.jpg" class="img-radius" alt="">
                    <span>{{userName}}</span>
                    <a href="javascript:" class="dud-logout" (click)="logout()" title="Logout">
                        <i class="feather icon-log-out"></i>
                    </a>
                </div>
                <ul class="pro-body">
                    <!-- <ul class="pro-body"> -->
                    <!-- <li><a href="javascript:" class="dropdown-item"><i class="feather icon-user"></i> Profile</a></li>
                    <li><a href="javascript:" class="dropdown-item"><i class="feather icon-user"></i>Change Password</a></li> -->
                    <!-- <li><a href="javascript:" class="dropdown-item"> My Messages</a></li>
                    <li><a href="javascript:" class="dropdown-item"><i class="feather icon-lock"></i> Lock Screen</a></li> -->
                    <li>
                        <!-- <a href="javascript:" class="dropdown-item"> <strong>Designation :</strong> <span style="color: #008080;">{{designation}}</span></a> -->
                        <strong>Designation :</strong> <span style="color: #008080;">{{designation}}</span>
                    </li>
                    <li style="padding-top: 1em;">
                        <!-- <a href="javascript:" class="dropdown-item"> <strong>User Level :</strong> <span style="color: #008080;">{{userLevel}}</span> </a> -->
                        <strong>User Level :</strong> <span style="color: #008080;">{{userLevel}}</span>
                    </li>
                    <li style="padding-top: 1em;">
                        <!-- <a href="javascript:" class="dropdown-item"> <strong>User Level :</strong> <span style="color: #008080;">{{userLevel}}</span> </a> -->
                        <strong>User Group :</strong> <span style="color: #008080;">{{userGroup}}</span>
                    </li>
                </ul>
            </div>
        </div>
    </li>
    <li style="padding: 0px;">
        <span style="color: white">{{userName}}</span>
    </li>
</ul>

<section class="header-user-list" *ngIf="visibleUserList && !this.gradientConfig['rtl-layout']" [ngClass]="{'open': visibleUserList}" [@slideInOutLeft]>
    <app-chat-user-list (onChatToggle)="onChatToggle($event)" (onChatCollapse)="this.visibleUserList = !this.visibleUserList; this.chatMessage = false;"></app-chat-user-list>
</section>

<section class="header-chat" *ngIf="chatMessage && !this.gradientConfig['rtl-layout']" [ngClass]="{'open': chatMessage}" [@slideInOutLeft]>
    <app-chat-msg (onChatToggle)="this.chatMessage = !this.chatMessage" [friendId]="friendId"></app-chat-msg>
</section>

<section class="header-user-list" *ngIf="visibleUserList && this.gradientConfig['rtl-layout']" [ngClass]="{'open': visibleUserList}" [@slideInOutRight]>
    <app-chat-user-list (onChatToggle)="onChatToggle($event)" (onChatCollapse)="this.visibleUserList = !this.visibleUserList; this.chatMessage = false;"></app-chat-user-list>
</section>

<section class="header-chat" *ngIf="chatMessage && this.gradientConfig['rtl-layout']" [ngClass]="{'open': chatMessage}" [@slideInOutRight]>
    <app-chat-msg (onChatToggle)="this.chatMessage = !this.chatMessage" [friendId]="friendId"></app-chat-msg>
</section>

<app-ui-modal #viewDetailed [hideFooter]="true" [dialogClass]="'modal-lg'">
    <div class="app-modal-header">
        <h5 class="modal-title" style="color:black;"><span style="color: black;"><strong>Detailed Notification</strong></span></h5>
        <!-- <button type="button" class="close basic-close" style="margin-top:10px" data-dismiss="modal" aria-label="Close" (click)="stockHistory.hide()"><span aria-hidden="true">&times;</span></button> -->
    </div>
    <div class="app-modal-body">
        <div class="row m-1">
            <!-- <div class="col-md-3">
                <label style="color:black;"><b>Title</b></label>
            </div> -->
            <!-- <div class="col"> -->
            <p style="color:black;"><strong>{{viewHistoryMore.head}}</strong></p>
            <!-- </div> -->
        </div>
        <div class="row m-1">
            <!-- <div class="col-md-3">
                <label style="color:black;"><b>Content</b></label>
            </div> -->
            <!-- <div class="col"> -->
            <strong><p style="color: #008080;">{{viewHistoryMore.content}}</p></strong>
            <!-- </div> -->
        </div>
        <div class="btn-group float-right">
            <button type="button" class="btn btn-danger" (click)="viewDetailed.hide()">Close</button>
        </div>
    </div>
</app-ui-modal>